<template>
    <v-col cols="12" :md="mdSettings">
        <v-select
            :label="label"
            :items="items"
            v-model="modelValueProxy"
            :disabled="disabled"
            variant="underlined"
            hide-details
            :dirty="false"
        />
    </v-col>
</template>

<script>
/**
 * FormSelectField
 * Componentă reutilizabilă pentru câmpuri select
 *
 * Props:
 * - label: Eticheta câmpului
 * - items: Lista de opțiuni (array)
 * - modelValue: Valoarea selectată (two-way binding)
 * - disabled: Dacă este dezactivat
 */
export default {
    name: "FormSelectField",
    props: {
        label: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        modelValue: {
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        mdSettings:{
            type: String,
            default: '6',
            required: false,
        },
    },
    computed: {
        modelValueProxy: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
};
</script>
